import React, { createContext, useContext } from "react";
const IsChannelListContext = createContext(false);
export function IsChannelListProvider({ value, children, }) {
    return (React.createElement(IsChannelListContext.Provider, { value: value }, children));
}
export default function useIsChannelList() {
    const value = useContext(IsChannelListContext);
    return value;
}
//# sourceMappingURL=useIsChannelList.js.map